import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import LPContainer from '../LandingPage/LPContainer'
import { cn } from '~/core/ui/utils'

const getVisibilityItems = (t: (key: string) => string) => [
  {
    title: t('lp:talent_ai:visibility:problem:title'),
    description: t('lp:talent_ai:visibility:problem:titleList'),
    color: 'text-red-800',
    backgroundColor: 'bg-red-100',
    items: [
      t('lp:talent_ai:visibility:problem:item1'),
      t('lp:talent_ai:visibility:problem:item2'),
      t('lp:talent_ai:visibility:problem:item3')
    ],
    iconTitle: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none">
        <g clip-path="url(#clip0_1649_919)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.17244 0.754228C4.28184 0.644832 4.43021 0.583374 4.58492 0.583374H9.41492C9.56963 0.583374 9.718 0.644832 9.8274 0.754228L13.2457 4.17256C13.3551 4.28196 13.4166 4.43033 13.4166 4.58504V9.41504C13.4166 9.56975 13.3551 9.71812 13.2457 9.82752L9.8274 13.2459C9.718 13.3553 9.56963 13.4167 9.41492 13.4167H4.58492C4.43021 13.4167 4.28184 13.3553 4.17244 13.2459L0.754106 9.82752C0.64471 9.71812 0.583252 9.56975 0.583252 9.41504V4.58504C0.583252 4.43033 0.64471 4.28196 0.754106 4.17256L4.17244 0.754228ZM4.82654 1.75004L1.74992 4.82667V9.17342L4.82654 12.25H9.17329L12.2499 9.17342V4.82667L9.17329 1.75004H4.82654ZM6.99992 4.08337C7.32208 4.08337 7.58325 4.34454 7.58325 4.66671V7.00004C7.58325 7.32221 7.32208 7.58337 6.99992 7.58337C6.67775 7.58337 6.41659 7.32221 6.41659 7.00004V4.66671C6.41659 4.34454 6.67775 4.08337 6.99992 4.08337ZM6.99992 8.75004C6.67775 8.75004 6.41659 9.01121 6.41659 9.33337C6.41659 9.65554 6.67775 9.91671 6.99992 9.91671H7.00575C7.32792 9.91671 7.58909 9.65554 7.58909 9.33337C7.58909 9.01121 7.32792 8.75004 7.00575 8.75004H6.99992Z"
            fill="#6B323C"
          />
        </g>
        <defs>
          <clipPath id="clip0_1649_919">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    iconItem: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="4"
        viewBox="0 0 4 4"
        fill="none">
        <circle cx="2" cy="2" r="2" fill="#EE5959" />
      </svg>
    ),
    imageDesktop: '/img/feature/lp/m-problem.png',
    imageMobile: '/img/feature/lp/m-problem.png'
  },
  {
    title: t('lp:talent_ai:visibility:solution:title'),
    description: t('lp:talent_ai:visibility:solution:titleList'),
    color: 'text-green-800',
    backgroundColor: 'bg-green-100',
    items: [
      t('lp:talent_ai:visibility:solution:item1'),
      t('lp:talent_ai:visibility:solution:item2'),
      t('lp:talent_ai:visibility:solution:item3')
    ],
    iconTitle: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none">
        <path
          d="M12.8333 3.5C13.1553 3.5 13.4171 3.76099 13.4172 4.08301V7.58301C13.4172 7.90517 13.1554 8.16699 12.8333 8.16699C12.5112 8.16689 12.2502 7.90511 12.2502 7.58301V5.49121L8.28735 9.4541C8.05954 9.68183 7.68994 9.68188 7.46216 9.4541L4.95825 6.9502L1.57935 10.3291C1.35154 10.5569 0.981956 10.5569 0.75415 10.3291C0.526459 10.1013 0.526383 9.73167 0.75415 9.50391L4.54614 5.71289C4.77395 5.48508 5.14353 5.48508 5.37134 5.71289L7.87524 8.2168L11.425 4.66699H9.33325C9.01117 4.66689 8.75024 4.40511 8.75024 4.08301C8.75042 3.76105 9.01128 3.5001 9.33325 3.5H12.8333Z"
          fill="#3A6F59"
        />
      </svg>
    ),
    iconItem: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2559 4.4107C17.5814 4.73614 17.5814 5.26378 17.2559 5.58922L8.08926 14.7559C7.76382 15.0813 7.23618 15.0813 6.91074 14.7559L2.74408 10.5892C2.41864 10.2638 2.41864 9.73614 2.74408 9.4107C3.06951 9.08527 3.59715 9.08527 3.92259 9.4107L7.5 12.9881L16.0774 4.4107C16.4028 4.08527 16.9305 4.08527 17.2559 4.4107Z"
          fill="#5CBB90"
        />
      </svg>
    ),
    imageDesktop: '/img/feature/lp/m-solution.png',
    imageMobile: '/img/feature/lp/m-solution.png'
  }
]

const VisibilityItem: FC<{ title: string; icon: React.ReactNode }> = ({
  title,
  icon
}) => {
  return (
    <li className="flex items-center">
      {icon}
      <span className="text-base text-gray-700 font-medium ml-3">{title}</span>
    </li>
  )
}

const VisibilityType: FC<{
  title: string
  description: string
  items: string[]
  iconTitle: React.ReactNode
  iconItem: React.ReactNode
  imageDesktop: string
  imageMobile: string
}> = ({
  title,
  description,
  items,
  iconTitle,
  iconItem,
  imageDesktop,
  imageMobile
}) => {
  return (
    <div className="bg-white pt-9 tablet:px-10">
      <h3
        className={cn(
          'inline-flex items-center justify-center gap-1.5 py-0.5 px-2 rounded-xl text-sm font-medium leading-5 text-center mb-3',
          title.includes('problem')
            ? 'text-red-800 bg-red-100'
            : 'text-green-800 bg-green-100'
        )}>
        {iconTitle}
        {title}
      </h3>
      <h3 className="text-gray-900 text-lg font-semibold mb-2">
        {title.includes('solution') && (
          <span className="text-blue-500">Talent AI </span>
        )}
        {description}
      </h3>
      <ul className="space-y-3 text-gray-700">
        {items.map((item: string) => (
          <VisibilityItem
            key={`${title}-${item}`}
            title={item}
            icon={iconItem}
          />
        ))}
      </ul>
      <picture>
        <source media="(min-width: 768px)" srcSet={imageDesktop} />
        <source media="(max-width: 767px)" srcSet={imageMobile} />
        <img alt="Talent AI Hero" loading="lazy" />
      </picture>
    </div>
  )
}

const VisibilitySection: FC = () => {
  const { t } = useTranslation()

  return (
    <div className="relative pt-16 tablet:pt-24 desktop:pt-32 bg-white">
      <LPContainer>
        <div className="mx-auto relative">
          {/* Left Line */}
          <picture className="hidden tablet:block absolute left-0 top-0 bottom-0 z-10">
            <source
              media="(min-width: 768px)"
              srcSet="/img/feature/lp/d-line.png"
            />
            <source
              media="(max-width: 767px)"
              srcSet="/img/feature/lp/m-line.png"
            />
            <img alt="" className="h-full" aria-hidden="true" />
          </picture>
          {/* Right Line */}
          <picture className="hidden tablet:block absolute right-0 top-0 bottom-0 z-10">
            <source
              media="(min-width: 768px)"
              srcSet="/img/feature/lp/d-line.png"
            />
            <source
              media="(max-width: 767px)"
              srcSet="/img/feature/lp/m-line.png"
            />
            <img alt="" className="h-full" aria-hidden="true" />
          </picture>
          {/* Mobile Version */}
          <div className="tablet:hidden mb-4">
            <h2 className="font-heading text-[37px] font-semibold leading-[42px] text-gray-900 text-center">
              Move faster with full
              <br />
              visibility into
              <br />
              your workforce
            </h2>
          </div>
          <p className="tablet:hidden text-[16px] text-gray-700 text-center pb-12 pb-9 mx-auto">
            {t('lp:talent_ai:visibility:subtitle')}
          </p>

          {/* Desktop/Tablet Version */}
          <div className="hidden tablet:block pb-4">
            <h2 className="font-heading text-[37px] font-semibold leading-[42px] text-gray-900 text-center">
              Move faster with full visibility into
              <br />
              your workforce
            </h2>
          </div>
          <p className="hidden tablet:border-l tablet:border-r border-gray-100 tablet:block text-[16px] text-gray-700 text-center pb-[42px] mx-auto">
            {t('lp:talent_ai:visibility:subtitle')}
          </p>
        </div>
      </LPContainer>
      <div className="border-t border-b border-gray-100">
        <LPContainer>
          <div className="tablet:border-l tablet:border-r border-gray-100">
            <div className="grid tablet:grid-cols-2 gap-8 relative tablet:after:content-[''] tablet:after:absolute tablet:after:left-1/2 tablet:after:top-0 tablet:after:bottom-0 tablet:after:w-px tablet:after:bg-gray-100 tablet:after:-translate-x-1/2">
              {getVisibilityItems(t).map((item) => (
                <VisibilityType
                  key={`${item.title}-${item.description}`}
                  title={item.title}
                  description={item.description}
                  items={item.items}
                  iconTitle={item.iconTitle}
                  iconItem={item.iconItem}
                  imageDesktop={item.imageDesktop}
                  imageMobile={item.imageMobile}
                />
              ))}
            </div>
          </div>
        </LPContainer>
      </div>
    </div>
  )
}

export default VisibilitySection
